import { FormikContextType } from 'formik';
import { ErrorMessage } from 'shared/styles';

export const getFieldError = <T,>(formik: FormikContextType<T>, fieldName: string): JSX.Element => {
  const meta = formik.getFieldMeta(fieldName);
  const errorText = meta.touched && meta.error ? meta.error : '';
  return !!errorText ? <ErrorMessage>{errorText}</ErrorMessage> : <div />;
};
